'use client';

import { Star } from 'lucide-react';
import { useTranslations } from 'next-intl';

import { cn } from '@/lib/utils';

interface AppRatingLineProps {
  className?: string;
}

export function AppRatingLine({ className }: AppRatingLineProps) {
  const t = useTranslations('landing.hero.appRating');

  return (
    <p
      data-testid="landing-app-rating"
      className={cn(
        'flex items-center justify-center lg:justify-start gap-1.5 text-sm text-muted-foreground',
        className,
      )}
    >
      <Star aria-hidden="true" className="h-4 w-4 shrink-0 fill-amber-400 text-amber-400" />
      <span>{t('line')}</span>
    </p>
  );
}
